// Shared placeholder body for every unimplemented tab.
//
// Every tab in the 9-tab strip renders through this component until Codex's
// design lands. The next bot swaps the placeholder for real UI without
// changing the routing.
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useHubSpotContext } from '../auth/hubspotContext.js';

export interface TabPlaceholderProps {
  tabName: string;
  // Notes to the next bot about the shape of data this tab will need. Kept
  // as static prose so the placeholder rendering conveys the wiring plan
  // without executing any API call yet.
  wiringNotes?: string;
}

export function TabPlaceholder({
  tabName,
  wiringNotes,
}: TabPlaceholderProps): ReactNode {
  const params = useParams();
  const context = useHubSpotContext();
  const contactId = params.contactId ?? '(no contact scope)';
  const contextSummary =
    context.status === 'ready'
      ? `user=${context.context.userId} portal=${context.context.portalId} objectId=${context.context.objectId ?? 'none'}`
      : `context=${context.status}`;
  return (
    <section aria-label={`${tabName} placeholder`}>
      <h1 style={{ margin: '0 0 12px', fontSize: 20 }}>{tabName}</h1>
      <div style={{ marginBottom: 12 }}>
        Placeholder for {tabName}. Real UI arrives after Codex's design pass.
      </div>
      <div style={{ fontSize: 12, color: '#555' }}>
        Contact: <code>{contactId}</code>
      </div>
      <div style={{ fontSize: 12, color: '#555' }}>
        HubSpot context: <code>{contextSummary}</code>
      </div>
      {wiringNotes ? (
        <p
          style={{
            marginTop: 16,
            padding: 12,
            background: '#f6f6f6',
            borderRadius: 4,
            fontSize: 13,
            color: '#333',
          }}
        >
          <strong>Wiring plan:</strong> {wiringNotes}
        </p>
      ) : null}
    </section>
  );
}
